import api from '../../../api/client';
import React from "react";
// import BalanceSheetTable from "./BalanceSheetTable";
import AccountingReports from "../../../components/accounts/accountsReport";
const BalanceSheet = () => {
  return (
    <>
      {/* <BalanceSheetTable /> */}
      <AccountingReports reportType="balance-sheet" />
    </>
  );
};

export default BalanceSheet;
